import type { FC } from 'react';
import { useTranslation } from 'react-i18next';
import { useSelector } from 'react-redux';
import BoostIconFilled from '@wix/da-ds/pkg/Icons/16x16/BoostFilled';
import { IconSize } from '@wix/da-ds/pkg/Icons/IconWrap';
import { getBoostRestrictions } from '../../selectors/studio/products';
import { getHasResults, getIsBoostSupported } from '../../selectors/studio';

import s from './FreeBoostsPromoBanner.scss';

interface Props {}

const FreeBoostsPromoBanner: FC<Props> = () => {
  const { t } = useTranslation();
  const isBoostSupported = useSelector(getIsBoostSupported);
  const hasResults = useSelector(getHasResults);
  const boostRestrictions = useSelector(getBoostRestrictions);
  const freeBoostsRemaining = boostRestrictions?.freeBoostsRemaining ?? 0;
  if (
    !isBoostSupported ||
    !hasResults ||
    freeBoostsRemaining < 1
  ) {
    return null;
  }

  return (
    <div className={s['root']}>
      <BoostIconFilled
        className={s['icon']}
        size={IconSize.SMALL}
        disableDefaultColors
      />
      <div className={s['text']}>
        {t('studio.header.freeBoostsPromoBanner.text', { freeBoostsRemaining })}
      </div>
      <div className={s['text-narrow']}>
        {t('studio.header.freeBoostsPromoBanner.text.narrow', {
          freeBoostsRemaining,
        })}
      </div>
    </div>
  );
};
FreeBoostsPromoBanner.displayName = 'FreeBoostsPromoBanner';

export default FreeBoostsPromoBanner;
